module.exports = __webpack_public_path__ + "887632cb56df331eb77de3ff1dae1158.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/module0.png
// module id = 1377
// module chunks = 0